import { onFirstInteraction } from "./utilities-BFAI3Dmv.js";
import "./waapi-patch-BCt4pEht.js";
import "./cookie-banner-layout-DZP7Q0uT.js";
import "./section-anchor-scroll-Bvm-mXVl.js";
import "./mobile-anim-gate-Btn1wVuD.js";
class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (!(template instanceof HTMLTemplateElement)) return;
      const shadow = this.attachShadow({ mode: "open" });
      shadow.append(template.content.cloneNode(true));
    }
  }
}
onFirstInteraction(() => {
  let _lockTimer = 0;
  let _startVW = 0;
  let _startVH = 0;
  let _isLocked = false;
  window.__isResizing = false;
  window.addEventListener("resize", () => {
    const currentVW = window.innerWidth;
    const root = document.documentElement;
    const currentVH = window.innerHeight;
    const isDesktop = currentVW >= 990;
    if (!window.__isResizing) {
      window.__isResizing = true;
      _startVW = currentVW;
      _startVH = currentVH;
    }
    if (isDesktop && !_isLocked) {
      if (Math.abs(currentVW - _startVW) > 50 || Math.abs(currentVH - _startVH) > 50) {
        _isLocked = true;
        root.style.setProperty("--100vw", currentVW + "px");
        root.style.setProperty("--100svh", currentVH + "px");
        root.style.setProperty("--100dvh", currentVH + "px");
      }
    }
    clearTimeout(_lockTimer);
    _lockTimer = setTimeout(() => {
      if (_isLocked) {
        root.style.removeProperty("--100vw");
        root.style.removeProperty("--100svh");
        root.style.removeProperty("--100dvh");
        _isLocked = false;
      }
      window.__isResizing = false;
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event("resize-settled"));
      });
    }, 100);
  }, { passive: true });
});
export {
  DeclarativeShadowElement
};
